import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { style: {"position":"relative"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "fs-22" }
const _hoisted_4 = { class: "text-muted" }
const _hoisted_5 = {
  key: 0,
  class: "disabledChatLabel"
}
const _hoisted_6 = { class: "chatMessageContainer" }
const _hoisted_7 = { class: "chatWriter" }
const _hoisted_8 = {
  key: 0,
  class: "quotedMessage"
}
const _hoisted_9 = { class: "sender" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 1,
  class: "chatInput"
}
const _hoisted_12 = {
  key: 0,
  class: "chatInputTop"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "chatInputTop" }
const _hoisted_15 = { class: "chatInputBottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_chat_message = _resolveComponent("chat-message")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_file_input = _resolveComponent("file-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.chatUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.chatUser.personalData.completeName), 1),
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "fs-22" }, null, -1)),
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "fs-22" }, null, -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _cache[9] || (_cache[9] = _createTextVNode("Iscrizione club: ")),
              (_ctx.clubSubscription)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("#" + _toDisplayString(_ctx.clubSubscription.number) + " - scad: " + _toDisplayString(_ctx.$filters.date(_ctx.clubSubscription.expiresOn)), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("Nessuna")
                  ], 64))
            ]),
            _createElementVNode("div", null, [
              _cache[10] || (_cache[10] = _createTextVNode("Iscrizione incaricato: ")),
              (_ctx.agentSubscription)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("#" + _toDisplayString(_ctx.agentSubscription.number) + " - scad: " + _toDisplayString(_ctx.$filters.date(_ctx.agentSubscription.expiresOn)), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("Nessuna")
                  ], 64))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("div", null, [
        (_ctx.chat.disabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.isTicket ? 'Ticket chiuso' : 'Stanza disabilitata'), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (item, i) => {
          return (_openBlock(), _createBlock(_component_chat_message, {
            key: i,
            onDblclick: _withModifiers(($event: any) => (_ctx.onDblClick(item)), ["stop","prevent"]),
            message: item,
            canRemove: _ctx.canEdit,
            onRemoveMessage: _ctx.toggleRemoveMessage,
            "messages-to-remove": _ctx.messagesToRemove
          }, null, 8, ["onDblclick", "message", "canRemove", "onRemoveMessage", "messages-to-remove"]))
        }), 128))
      ])
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.showNuoviMessaggi)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "newChatMessages",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToBottom && _ctx.goToBottom(...args)))
            }, [
              _createElementVNode("span", null, [
                _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fa fa-arrow-down" }, null, -1)),
                _cache[14] || (_cache[14] = _createTextVNode()),
                _createVNode(_component_localized_text, {
                  localizedKey: "nuovi messaggi",
                  text: "nuovi messaggi"
                }),
                _cache[15] || (_cache[15] = _createTextVNode()),
                _cache[16] || (_cache[16] = _createElementVNode("i", { class: "fa fa-arrow-down" }, null, -1))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.quotedMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("button", {
              class: "cancel",
              type: "button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelQuote && _ctx.cancelQuote(...args)))
            }, "X"),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.quotedMessage.sender), 1),
            _createElementVNode("span", {
              class: "ellipsis",
              innerHTML: _ctx.quotedMessage.text
            }, null, 8, _hoisted_10)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.readonly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            (_ctx.imgPreview)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("img", { src: _ctx.imgPreview }, null, 8, _hoisted_13),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary ms-1",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.sendImg && _ctx.sendImg(...args)))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Invia",
                      text: "Invia"
                    })
                  ])
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_14, [
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.messageText) = $event)),
                      class: "form-control",
                      onKeypress: _cache[4] || (_cache[4] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.addReturn && _ctx.addReturn(...args)), ["prevent","shift"]), ["enter"])),
                      onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)), ["exact"]), ["enter"]))
                    }, "                        ", 544), [
                      [_vModelText, _ctx.messageText]
                    ]),
                    (_ctx.messagesToRemove.length > 0)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-danger",
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.removeMessages && _ctx.removeMessages(...args)))
                        }, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Rimuovi messaggi selezionati",
                            text: "Rimuovi messaggi selezionati"
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("label", {
                      class: _normalizeClass(["imageUploader btn btn-primary ms-1", { 'disabled': _ctx.fileToUpload }])
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Allega immagine",
                        text: "Allega immagine"
                      }),
                      (_ctx.fileToUpload == null)
                        ? (_openBlock(), _createBlock(_component_file_input, {
                            key: 0,
                            modelValue: _ctx.fileToUpload,
                            "onUpdate:modelValue": [
                              _cache[7] || (_cache[7] = ($event: any) => ((_ctx.fileToUpload) = $event)),
                              _ctx.uploadFile
                            ],
                            class: "d-none"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                        : _createCommentVNode("", true)
                    ], 2)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["btn btn-primary btn-block", {'disabled': !_ctx.messageText.trim() }]),
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)))
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Invia",
                        text: "Invia"
                      })
                    ], 2)
                  ])
                ], 64))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}